import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clone as t } from "../lang.js";
import { assumeNonNull as e } from "../maybe.js";
import { merge as r } from "./utils.js";

var o = function o(t) {
  _classCallCheck(this, o);

  this.autoDestroy = !1, this.properties = t;
};

function n(r) {
  var n = r.constructor.__accessorMetadata__;
  var c = Object.prototype.hasOwnProperty.call(r.constructor, "__accessorMetadata__");

  if (n) {
    if (!c) {
      var _e = Object.create(n.properties),
          _c = n.autoDestroy;

      for (var _r in _e) {
        _e[_r] = t(_e[_r]);
      }

      n = new o(_e), n.autoDestroy = _c, Object.defineProperty(r.constructor, "__accessorMetadata__", {
        value: n,
        enumerable: !1,
        configurable: !0,
        writable: !0
      });
    }
  } else n = new o({}), Object.defineProperty(r.constructor, "__accessorMetadata__", {
    value: n,
    enumerable: !1,
    configurable: !0,
    writable: !0
  });

  return e(r.constructor.__accessorMetadata__);
}

function c(t) {
  return n(t).properties;
}

function s(t, e) {
  var r = c(t);
  var o = r[e];
  return o || (o = r[e] = {}), o;
}

function a(t, e, r) {
  c(t)[e] = r;
}

function u(t, e) {
  return r(t, e, f);
}

function i(t, e) {
  return r(t, e, _);
}

var p = /^(?:[^.]+\.)?(?:value|type|(?:json\.type|json\.origins\.[^.]\.type))$/;

function _(t) {
  return p.test(t) ? "replace" : "merge";
}

var l = /^properties\./;

function f(t) {
  return l.test(t) ? _(t.slice(11)) : "merge";
}

export { o as ClassMetadata, n as getOwnClassMetadata, c as getOwnPropertiesMetadata, s as getOwnPropertyMetadata, u as merge, i as mergeProperty, a as setPropertyMetadata };